import { WalletSlice } from '../slice'
import { getTickets } from './getTickets'

export const WalletActions = {
  ...WalletSlice.actions,
  getTickets,
}
